module.exports = __webpack_public_path__ + "static/media/speech_18.ca1022c7.svg";